import { useEffect, useRef } from 'react';

/**
 * Runs the effect only when dependencies update, not on initial mount.
 */
export const useUpdateEffect = (
  effect: () => void | (() => void),
  deps: React.DependencyList,
  shouldSkip?: boolean
) => {
  const isInitial = useRef(true);

  useEffect(() => {
    if (shouldSkip) return;

    if (isInitial.current) {
      isInitial.current = false;
      return;
    }

    const cleanup = effect();
    return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
